import { makeStyles } from '@material-ui/core/styles';

export type ButtonCssProps = {
  borderRadius?: number;
  textTransform?: 'capitalize' | 'lowercase' | 'uppercase' | 'unset' | 'initial';
};

export const useStyles = makeStyles(() => ({
  root: {
    paddingTop: '13px',
    paddingBottom: '13px',
    borderRadius: ({ borderRadius }: ButtonCssProps) => (borderRadius ? borderRadius : borderRadius === 0 ? 0 : 10),
  },
  defaultLabel: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '23px',
    textTransform: ({ textTransform = 'initial' }: ButtonCssProps) => textTransform,
  },
}));
